// client/src/components/common/MediaPreview.jsx

import React from 'react'; // 1. Importar React completo
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTimes,
  faCheck,
  faStar,
  faWandMagicSparkles,
  faEye,
} from '@fortawesome/free-solid-svg-icons';

const MediaPreview = ({
  preview,
  index,
  onRemove,
  disabled,
  isPremium,
  onEditEffect,
  isCover,
  onSetCover,
  children,
  isUserView,
  effect,
}) => {
  const { t } = useTranslation();

  const canEditEffect = isPremium && typeof onEditEffect === 'function';

  return (
    <div
      className={`relative bg-white dark:bg-neutral-800 rounded-xl shadow-card p-2 flex flex-col items-center group transition-shadow border
      ${
        isCover
          ? 'ring-2 ring-primary border-primary'
          : 'border-neutral-200 dark:border-neutral-700'
      }`}
    >
      {isCover && (
        <div className="absolute top-1.5 left-1.5 z-10 bg-primary text-white text-xs font-bold px-2 py-0.5 rounded-full shadow flex items-center gap-1">
          <FontAwesomeIcon icon={faStar} size="xs" />
          {t('media_previews.media_item.cover_badge')}
        </div>
      )}

      <div className="relative w-full aspect-square bg-neutral-100 dark:bg-neutral-700 rounded-lg overflow-hidden mb-2">
        {preview.url ? (
          <img
            src={preview.url}
            alt={t('media_previews.media_item.alt_text', { index })}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full bg-neutral-200 dark:bg-neutral-800 animate-pulse" />
        )}

        {/* --- INICIO DE LA CORRECCIÓN --- */}
        {/* Simplemente renderizamos los children (íconos, etc.) tal como vienen. */}
        {/* No necesitan la prop 'isUserView', que era lo que causaba el error. */}
        {children}
        {/* --- FIN DE LA CORRECCIÓN --- */}

        {isUserView && effect && (
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm flex flex-col items-center justify-center text-white p-2 text-center z-20">
            <FontAwesomeIcon icon={faEye} className="text-xl mb-1" />
            <span className="font-semibold text-xs">
              {t('preview.user_view_active', 'Vista de Usuario')}
            </span>
            <span className="text-[10px] opacity-80 capitalize">
              ({effect.type})
            </span>
          </div>
        )}

        {canEditEffect && !isUserView && (
          <div className="absolute inset-0 bg-black/30 lg:bg-black/50 opacity-100 lg:opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
            <button
              type="button"
              className="absolute top-2 right-2 w-8 h-8 flex items-center justify-center bg-black/40 hover:bg-black/60 text-white rounded-full transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={onEditEffect}
              disabled={disabled}
              aria-label={t('file_upload.edit_effect')}
            >
              <FontAwesomeIcon icon={faWandMagicSparkles} />
            </button>
          </div>
        )}
      </div>

      <div className="w-full flex items-center justify-center gap-2">
        {preview.type === 'image' && typeof onSetCover === 'function' && (
          <button
            type="button"
            className={`btn-secondary !text-xs !py-1.5 !px-3 flex-1 ${
              isCover
                ? '!bg-neutral-300 dark:!bg-neutral-600 cursor-default'
                : ''
            }`}
            onClick={() => onSetCover(index)}
            disabled={disabled || isCover}
          >
            {isCover && <FontAwesomeIcon icon={faCheck} className="mr-1.5" />}
            {isCover
              ? t('media_previews.media_item.is_cover_button')
              : t('media_previews.media_item.make_cover_button')}
          </button>
        )}

        <button
          type="button"
          onClick={() => onRemove(index)}
          disabled={disabled}
          className="bg-red-500/10 text-red-600 hover:bg-red-500 hover:text-white font-bold h-8 w-8 flex-shrink-0 rounded-full transition-colors"
          title={t('media_previews.media_item.delete_tooltip')}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>
    </div>
  );
};

export default MediaPreview;
